import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { hasAnalyticsConsent, CONSENT_EVENT } from "@/lib/analytics";

const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

// Site-wide after cookie consent; only the admin area is excluded.
export const pixelAllowedOn = (pathname) => Boolean(PIXEL_ID) && !pathname.startsWith("/admin");

const loadPixel = () => {
  if (window.fbq) return;
  const n = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  });
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = "2.0";
  n.queue = [];
  const t = document.createElement("script");
  t.async = true;
  t.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(t);
  window.fbq("set", "autoConfig", false, PIXEL_ID);
  window.fbq("init", PIXEL_ID);
};

const MetaPixel = () => {
  const { pathname } = useLocation();
  const [consented, setConsented] = useState(false);

  useEffect(() => {
    const sync = () => setConsented(hasAnalyticsConsent());
    sync();
    window.addEventListener(CONSENT_EVENT, sync);
    return () => window.removeEventListener(CONSENT_EVENT, sync);
  }, []);

  useEffect(() => {
    if (!consented || !pixelAllowedOn(pathname)) return;
    loadPixel();
    window.fbq("track", "PageView");
  }, [consented, pathname]);

  return null;
};

export default MetaPixel;
